const POWERPOINT_FILE_EXTENSION_REGEX = /\.(ppt|pptx)$/i;
const WORD_FILE_EXTENSION_REGEX = /\.(doc|docx)$/i;
const EXCEL_LEGACY_FILE_EXTENSION_REGEX = /\.(xls)$/i;
const EXCEL_FILE_EXTENSION_REGEX = /\.(xlsx|xlsm)$/i;

export function getTemplateCandidateValues(template) {
  const userSuppliedTemplateDoc = template?.user_supplied_template_doc;
  return [
    template?.template_type,
    template?.filename,
    template?.name,
    userSuppliedTemplateDoc?.filename,
    userSuppliedTemplateDoc?.name,
    userSuppliedTemplateDoc?.file_extension,
    userSuppliedTemplateDoc?.content_type,
    userSuppliedTemplateDoc?.mime_type,
    userSuppliedTemplateDoc?.type,
  ].filter((value) => typeof value === 'string' && value.length > 0);
}

function matchesTemplateValue(candidateValues, regex, includesText = []) {
  return candidateValues.some((value) => {
    const normalizedValue = value.toLowerCase();
    return regex.test(value) || includesText.some((text) => normalizedValue.includes(text));
  });
}

export function getTemplateBinaryConfig(template) {
  const candidateValues = getTemplateCandidateValues(template);

  if (matchesTemplateValue(candidateValues, POWERPOINT_FILE_EXTENSION_REGEX, ['powerpoint', 'presentation'])) {
    return {
      endpointSuffix: 'template_pptx',
      dragDropProps: { pptx: true, includePdf: false },
      helperText: 'Drag and drop a PowerPoint file to replace this template. Only .ppt or .pptx files are supported.',
      isPowerPoint: true,
      isWord: false,
      isExcel: false,
      label: 'PowerPoint',
    };
  }

  if (matchesTemplateValue(candidateValues, WORD_FILE_EXTENSION_REGEX, ['word'])) {
    return {
      endpointSuffix: 'template_docx',
      dragDropProps: { docx: true, includePdf: false },
      helperText: 'Drag and drop a Word document to replace this template. Only .doc or .docx files are supported.',
      isPowerPoint: false,
      isWord: true,
      isExcel: false,
      label: 'Word',
    };
  }

  if (matchesTemplateValue(candidateValues, EXCEL_LEGACY_FILE_EXTENSION_REGEX, ['excel'])) {
    return {
      endpointSuffix: 'template_xlsx',
      dragDropProps: { xls: true, includePdf: false },
      helperText:
        'Drag and drop an Excel file to replace this template. Only .xls, .xlsx, or .xlsm files are supported.',
      isPowerPoint: false,
      isWord: false,
      isExcel: true,
      label: 'Excel',
    };
  }

  if (matchesTemplateValue(candidateValues, EXCEL_FILE_EXTENSION_REGEX, ['spreadsheet'])) {
    return {
      endpointSuffix: 'template_xlsx',
      dragDropProps: { xlsx: true, includePdf: false },
      helperText: 'Drag and drop an Excel file to replace this template. Only .xlsx or .xlsm files are supported.',
      isPowerPoint: false,
      isWord: false,
      isExcel: true,
      label: 'Excel',
    };
  }

  return {
    endpointSuffix: 'template_xlsx',
    dragDropProps: { xlsx: true, includePdf: false },
    helperText: 'Drag and drop an Excel file to replace this template. Only .xlsx or .xlsm files are supported.',
    isPowerPoint: false,
    isWord: false,
    isExcel: true,
    label: 'Excel',
  };
}

export function isPowerPointTemplate(template) {
  return getTemplateBinaryConfig(template).isPowerPoint;
}
